import React from "react";
import { default as WInputAdornment } from "@mui/material/InputAdornment";

function InputAdornment(props) {
  return <WInputAdornment {...props} />;
}

export default InputAdornment;
